"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var transform = exports.transform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "Lowercase", value: "lowercase" }]
};
var fontWeight = exports.fontWeight = {
  type: "select",
  options: [{ label: "Light", value: "300" }, { label: "Normal", value: "400" }, { label: "Medium", value: "500" }, { label: "Bold", value: "600" }]
};

var logoWidth = exports.logoWidth = {
  type: "select",
  options: [{ label: "140", value: "140px" }, { label: "150", value: "150px" }, { label: "180", value: "180px" }, { label: "200", value: "200px" }]
};

var logoHeight = exports.logoHeight = {
  type: "select",
  options: [{ label: "100", value: "100px" }, { label: "110", value: "110px" }, { label: "120", value: "120px" }, { label: "130", value: "130px" }]
};